import React, { useContext } from 'react';
import {
  AppContext,
  AppState,
  initialState,
} from '../../context/AppContext/context';

function useSearchModal() {
  const { state, dispatch } = useContext(AppContext);

  const open = React.useCallback(
    (options?: Omit<AppState['searchModal'], 'isOpen'>) => {
      dispatch({
        type: 'SET_SEARCH_MODAL',
        payload: {
          ...initialState.searchModal,
          ...options,
          isOpen: true,
        },
      });
    },
    [dispatch],
  );

  const close = React.useCallback(() => {
    dispatch({ type: 'SET_SEARCH_MODAL', payload: initialState.searchModal });
  }, [dispatch]);

  const toggle = React.useCallback(() => {
    dispatch({
      type: 'SET_SEARCH_MODAL',
      payload: {
        ...initialState.searchModal,
        isOpen: !state.searchModal.isOpen,
      },
    });
  }, [dispatch, state.searchModal.isOpen]);

  const update = React.useCallback(
    (options: Partial<AppState['searchModal']>) => {
      dispatch({
        type: 'SET_SEARCH_MODAL',
        payload: {
          ...state.searchModal,
          ...options,
        },
      });
    },
    [dispatch, state.searchModal],
  );

  return {
    isOpen: state.searchModal.isOpen,
    type: state.searchModal.type,
    appointmentsOnly: state.searchModal.appointmentsOnly,
    itemButton: state.searchModal.itemButton,
    placeholder: state.searchModal.placeholder,
    sort: state.searchModal.sort,
    appointmentStatus: state.searchModal.appointmentStatus,
    open,
    close,
    toggle,
    update,
  };
}

export default useSearchModal;
